import "../../css/views/contact.scss";
import { displayMsg, hightlightErr, unhighlightErr, validateFuncs } from "../common";

const submitBtn = document.getElementById( "submitBtn" ),
	contactFrm = document.getElementById( "contactFrm" );

submitBtn.addEventListener( 'click', e => {
	e.preventDefault();
	e.stopImmediatePropagation();

	const formData = new FormData( contactFrm )
	const validateResp = validateForm( formData )

	if ( validateResp.formIsValid )
		send( validateResp.pObj )

} );


async function send( pObj ) {
	displayMsg( 'wait' )
	submitBtn.setAttribute( "disabled", true );

	await fetch( '/wp-json/wp/v2/contact', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify( pObj ),
	} ).then( r => r.ok ? r.json() : displayMsg( "error" ) )
		.then( r => {
			if ( r && r.resp ) {
				displayMsg( "success" )
				setTimeout( () => {
					contactFrm.reset();
				}, 2000 );
			}

			setTimeout( () => {
				displayMsg( "" )
				submitBtn.removeAttribute( "disabled" );
			}, 2000 );
		} )

}

function validateForm( formData ) {
	let formIsValid = true

	let pObj = {}

	for ( const [ key, val ] of formData.entries() ) {
		const el = document.getElementById( key )
		const isRequired = el.hasAttribute( "required" )

		if ( isRequired && val == "" ) {
			hightlightErr( el, key, "Το πεδίο είναι υποχρεωτικό" )
			formIsValid = false
		} else {
			const validateMethod = el.dataset.validateMethod

			if ( validateMethod && !validateFuncs?.[ validateMethod ]( val ) ) {
				/* if a validate method is set but it does not return true */
				const msg = el.dataset.invalid
				hightlightErr( el, key, msg )
				formIsValid = false
			} else {
				/* if everything is fine */
				unhighlightErr( el, key )
				pObj[ key ] = val
			}

		}
	}

	return { formIsValid, pObj }
}